import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import "../css/styles.css";

const ThankYouPage = () => {
  useEffect(() => {
    // Animation effect when component mounts
    const checkmark = document.querySelector('.checkmark');
    if (checkmark) {
      setTimeout(() => {
        checkmark.classList.add('animate');
      }, 100);
    }
  }, []);

  return (
    <section className="py-20 bg-white min-h-screen flex items-center">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-2xl mx-auto">
          {/* Success Animation */}
          <div className="success-animation mb-8">
            <div className="checkmark-circle">
              <div className="checkmark"></div>
            </div>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-primary">Thank You!</h1>
          <p className="text-xl text-gray-700 mb-10">
            Your information has been successfully submitted. We're excited to have you join our exclusive waitlist!
          </p>
          
          <div className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">What's Next?</h2>
            <p className="text-lg text-gray-600 mb-6">
              Our team will review your application and reach out to you soon with more details about our launch and your exclusive benefits.
            </p>
          </div>
          
          {/* Social Links */}
          <div className="mb-10">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Follow Us</h3>
            <p className="text-gray-600 mb-6">Stay updated with our latest news and announcements</p>
            
            <div className="flex justify-center space-x-6">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full hover:bg-primary/10">
                  <i className="ri-instagram-line ri-lg"></i>
                </div>
                <span className="sr-only">Instagram</span>
              </a>
              
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full hover:bg-primary/10">
                  <i className="ri-facebook-fill ri-lg"></i>
                </div>
                <span className="sr-only">Facebook</span>
              </a>
              
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full hover:bg-primary/10">
                  <i className="ri-twitter-x-line ri-lg"></i>
                </div>
                <span className="sr-only">Twitter</span>
              </a>
              
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-primary transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full hover:bg-primary/10">
                  <i className="ri-linkedin-fill ri-lg"></i>
                </div>
                <span className="sr-only">LinkedIn</span>
              </a>
            </div>
          </div>
          
          <Link to="/" className="inline-block bg-primary text-white px-8 py-3 !rounded-button whitespace-nowrap hover:bg-primary-dark transition-colors font-medium">
            Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ThankYouPage;